<template>
  <div class="book">
    <swiper :options="swiperOptions">
      <swiper-slide v-for="item in bookList" :key="item.Id">
        <div class="box">
          <img :src="item.BookImg">
          <p>{{item.BookName}}</p>
        </div>
      </swiper-slide>
      <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
export default {
  name: "Book",
  // components: {
  //   Swiper,
  //   SwiperSlide
  // },
  props: {
    bookList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiperOptions: {
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 14,
        // autoplay: true,
        // loop: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.book{
  width: 1200px;
  margin: 0 auto 36px;
  .swiper-wrapper{
    display: flex;
    .swiper-slide{
      display: flex;
      height: auto;
    }
  }
  .box{
    width: 289px;
    background: #FFFFFF;
    box-shadow: 1px 15px 18px 1px rgba(0, 0, 0, 0.02);
    padding: 20px 19px 30px;
    text-align: center;
    box-sizing: border-box;
    img {
      height: 220px;
    }
    p{
      margin-top: 26px;
      color: #343434;
      font-size: 17px;
      font-weight: 400;
      line-height: 24px;
      text-align: left;
    }
  }
  .swiper-button-prev{
    background: url(https://img2.233.com/wx/union/pure/pc/btn_left.png) no-repeat;
    background-size: 100% 100%;
    width: 44px;
    height: 88px;
    margin-top: -44px;
    left: 0;
    &::after{
      content: "";
    }
    &:hover{
      background: url(https://img2.233.com/wx/union/pure/pc/btn_left_hover.png) no-repeat;
    }
  }
  .swiper-button-next{
    background: url(https://img2.233.com/wx/union/pure/pc/btn_right.png) no-repeat;
    background-size: 100% 100%;
    width: 44px;
    height: 88px;
    margin-top: -44px;
    right: 0;
    &::after{
      content: "";
    }
    &:hover{
      background: url(https://img2.233.com/wx/union/pure/pc/btn_right_hover.png) no-repeat;
    }
  }
}
</style>